// extracted by mini-css-extract-plugin
module.exports = {"card":"CreatePost_card__1Y5ev","form_wrapper":"CreatePost_form_wrapper__HwLsh","post_actions":"CreatePost_post_actions__31582","actions_btn":"CreatePost_actions_btn__qkJM3"};